import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Accordion } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { updatePost } from '../../services/upload-files.service';

const AssignGoal = () => {
    const loading = useSelector((state) => state.teammanagement.loading);
    const error = useSelector((state) => state.teammanagement.error);
    const employeeData = useSelector((state) => state.teammanagement.data.employee);
    const departmentData = useSelector((state) => state.teammanagement.data.department);
    const supplierData = useSelector((state) => state.teammanagement.data.supplier);
    const [departmentSupervisors, setDepartmentSupervisors] = useState({});
    const [activeAccordionKey, setActiveAccordionKey] = useState('');
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState([]);
    const [searchKeyword, setSearchKeyword] = useState('');
    const { state } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const departmentIds = state.department.map((data) => data.id);
        setSelectedDepartment(departmentIds);
        const employeeIds = state.employees.map((data) => data.id);
        setSelectedEmployee(employeeIds);
        const supplierIds = state.supplier.map((data) => data.id);
        setSelectedSupplier(supplierIds);
    }, [state.department, state.employees, state.supplier]);

    const handleRowClick = (depId) => {
        if (activeAccordionKey === depId) {
            setActiveAccordionKey('');
        } else {
            const supervisor = employeeData.results.filter(
                (sup) => sup.department_id === depId && sup.is_supervisor === 1
            );

            if (supervisor.length > 0) {
                const employees = employeeData.results.filter(
                    (emp) => emp.department_id === depId && emp.is_supervisor === 0
                );

                const updatedSupervisors = supervisor.map((sup) => {
                    const employeeSubordinates = employees.filter(
                        (emp) => emp.supervisor_id === sup.id
                    );
                    return {
                        ...sup,
                        empl: employeeSubordinates,
                    };
                });

                setDepartmentSupervisors((prevState) => ({
                    ...prevState,
                    [depId]: updatedSupervisors,
                }));
            } else {
                const employees = employeeData.results.filter(
                    (emp) => emp.department_id === depId && emp.is_supervisor === 0
                );

                setDepartmentSupervisors((prevState) => ({
                    ...prevState,
                    [depId]: employees,
                }));
            }

            setActiveAccordionKey(depId);
        }
    };

    const handleAssignClick = () => {
        const formData = {
            goal_id: state.goal.id,
            department_id: selectedDepartment,
            employee_id: selectedEmployee,
            supplier_id: selectedSupplier,
        };

        if (Object.keys(formData).length > 0) {
            updatePost(formData, 'goals/assign').then((res) => {
                if (res && Object.keys(res).length > 0) {
                    const route = "/goaldetailpage";
                    navigate(route, { state: { id: state.goal.id } });
                } else {
                    return <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                            <h1 className="h2">
                                jjj
                            </h1>
                        </div>
                    </main>
                }
            });
        }
    };

    const handleDepartmentCheckboxChange = (depId) => {
        if (selectedDepartment.includes(depId)) {
            setSelectedDepartment((prevState) =>
                prevState.filter((id) => id !== depId)
            );
        } else {
            setSelectedDepartment((prevState) => [...prevState, depId]);
        }
    };

    const handleEmployeeCheckboxChange = (empId) => {
        if (selectedEmployee.includes(empId)) {
            setSelectedEmployee((prevState) =>
                prevState.filter((id) => id !== empId)
            );
        } else {
            setSelectedEmployee((prevState) => [...prevState, empId]);
        }
    };

    const handleSupplierCheckboxChange = (supId) => {
        if (selectedSupplier.includes(supId)) {
            setSelectedSupplier((prevState) =>
                prevState.filter((id) => id !== supId)
            );
        } else {
            setSelectedSupplier((prevState) => [...prevState, supId]);
        }
    };

    const handleSearchChange = (event) => {
        setSearchKeyword(event.target.value);
    };

    const filteredDepartments = departmentData.results.filter((department) =>
        department.department_name.toLowerCase().includes(searchKeyword.toLowerCase())
    );
    
    const GoalId = {
        id: state.goal.id,
    }
    if (loading) {
        return (
            <>
                <main className="col-md-12">
                    <h1 className="h2 py-2"> <i class="fa-solid fa-spinner fa-spin"></i></h1>
                </main>
            </>
        )
    }

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                    <h1 className="h2">
                        <Link to="/goaldetailpage" state={GoalId}>
                            <i className="fa-solid fa-arrow-left"></i>
                        </Link>{' '}
                        {state.goal.goal_name}
                    </h1>
                    <button className="btn-orange" onClick={handleAssignClick}>
                        Assign&nbsp;
                    </button>
                </div>
                <div className="form-outline mb-4">
                    <input
                        type="search"
                        className="form-control"
                        id="datatable-search-input"
                        placeholder="Search departments by name"
                        value={searchKeyword}
                        onChange={handleSearchChange}
                    />
                </div>
                {filteredDepartments.length > 0 ? (
                    filteredDepartments.map((curData) => {
                        const { id, department_name } = curData;
                        const supervisors = departmentSupervisors[id] || [];
                        return (
                            <div key={id} className="goalaccordian" id={id}>
                                <Accordion activeKey={activeAccordionKey}>
                                    <Accordion.Item eventKey={id}>
                                        <Accordion.Header onClick={() => handleRowClick(id)}>
                                            <input
                                                className="form-check-input chkAll me-2"
                                                type="checkbox"
                                                value=""
                                                id={id}
                                                checked={selectedDepartment.includes(id)}
                                                onChange={() => handleDepartmentCheckboxChange(id)}
                                            />{' '}
                                            {department_name}
                                        </Accordion.Header>
                                        {/* <------------- supervisor ----------> */}
                                        <Accordion.Body>
                                            {supervisors.length > 0 ? (
                                                supervisors.map((supData) => {
                                                    const { id, name, empl } = supData;
                                                    return (
                                                        <div className="checkboxbody" key={`${id}sup`}>
                                                            <div className="form-check">
                                                                <label>
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        value=""
                                                                        checked={selectedEmployee.includes(id)}
                                                                        onChange={() => handleEmployeeCheckboxChange(id)}
                                                                    />
                                                                    {name}
                                                                </label>
                                                                {/*<---------- employee ------------> */}
                                                                {empl && empl.length > 0 ? (
                                                                    empl.map((empData) => {
                                                                        const { id, name } = empData;
                                                                        return (
                                                                            <div className="subcheckbox" key={`${id}emp`}>
                                                                                <label>
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        value=""
                                                                                        checked={selectedEmployee.includes(id)}
                                                                                        onChange={() => handleEmployeeCheckboxChange(id)}
                                                                                    />
                                                                                    {name}
                                                                                </label>
                                                                            </div>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    
                                                                    <span>
                                                                        <br />
                                                                                                                                            </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <span>No employee data available.</span>
                                               // <span>No supervisor data available.</span>
                                            )}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        );
                    })
                ) : (
                    <span>No data found.</span>
                )}
                <div>
                    <span className='goalheading'>Supplier</span>
                    {supplierData.results.length > 0 ? (
                        supplierData.results.map((suplierpData) => {
                            const { id, name } = suplierpData;
                            return (
                                <div className="checkboxbody" key={`${id}supplier`}>
                                    <div className="form-check">
                                        <label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                value=""
                                                checked={selectedSupplier.includes(id)}
                                                onChange={() => handleSupplierCheckboxChange(id)}
                                            />
                                            {name}
                                        </label>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <span>No supplier data available.</span>
                    )}
                </div>
            </main >
        </>
    );
};

export default AssignGoal;
